import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-white">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <i className="ri-book-open-line text-2xl text-primary-400"></i>
              <span className="text-xl font-bold font-heading">韩漫在线</span>
            </div>
            <p className="text-background-400 text-sm leading-relaxed">
              最全的韩国漫画在线阅读平台，提供下拉式阅读体验，随时随地享受精彩韩漫故事。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-200">
              <a href="#category-nav" className="hover:text-primary-400 transition-colors">热门分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-background-400 hover:text-primary-400 text-sm transition-colors"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-200">
              <a href="#" className="hover:text-primary-400 transition-colors">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-background-400 hover:text-primary-400 text-sm transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-background-400 hover:text-primary-400 text-sm transition-colors">关于我们</Link>
              </li>
              <li>
                <a href="#faq" className="text-background-400 hover:text-primary-400 text-sm transition-colors">常见问题</a>
              </li>
              <li>
                <Link to="/about" className="text-background-400 hover:text-primary-400 text-sm transition-colors">联系我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-200">联系我们</h4>
            <ul className="space-y-2.5 text-background-400 text-sm">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@koreancomics.cn</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-primary-400"></i>
                <span>微信公众号：韩漫在线</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-smartphone-line text-primary-400"></i>
                <span>客服热线：400-888-8888</span>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-white transition-all" rel="nofollow" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-white transition-all" rel="nofollow" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-white transition-all" rel="nofollow" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-500 text-xs">
            &copy; {new Date().getFullYear()} 韩漫在线 koreancomics.cn - 韩国漫画在线阅读平台 版权所有
          </p>
          <div className="flex items-center gap-4 text-background-500 text-xs">
            <a href="#" className="hover:text-primary-400 transition-colors">用户协议</a>
            <a href="#" className="hover:text-primary-400 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}